<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <div class="d-flex align-items-center">
                <div class="edit">
                  <button (click)="backToMyProjectV2()">
                    <span><i class="ri-arrow-left-line"></i></span>
                  </button>
                </div>
                <h3 class="px-3">My Project</h3>
              </div>
            </div>
          </div>
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6 d-flex">
              <h3><a class="active">Sub-Project</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('task-v2')">Tasks</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('resource-v2')">Resources</a></h3>
            </div>
          </div>
          <div class="canvas-data">
            <form [formGroup]="projectv2Form">
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="regionName" id="regionName" />
                      <label class="floating-label-special">Region*</label>
                      <i class="ri-global-fill"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="industryName" id="industryName" />
                      <label class="floating-label-special">Industry</label>
                      <i class="ri-global-fill"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="businessGroupName" id="businessGroupName" />
                      <label class="floating-label-special">Business Group</label>
                      <i class="ri-global-fill"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="commodityName" id="commodityName" />
                      <label class="floating-label-special">Commodity</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="activityName" id="activityName" />
                      <label class="floating-label-special">Activity</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectSoftwareName" id="projectSoftwareName" />
                      <label class="floating-label-special">Project Software</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="parentProjectName" id="projectName" />
                      <label class="floating-label-special">Project Name</label>
                      <i class="ri-archive-drawer-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectName"/>
                      <label class="floating-label-special">Sub Project Name*</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectCode"/>
                      <label class="floating-label-special">Sub Project Code*</label>
                      <i class="ri-hashtag"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input list="taskOwnerDatalist" placeholder="Select Project Manager" formControlName="projectManagerName" />
                      <datalist id="taskOwnerDatalist">
                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                      </datalist>
                      <label class="floating-label-special">Project Manager*</label>
                      <i class="ri-user-2-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input list="taskOwnerDatalist" placeholder="Select Project Lead" formControlName="projectLeadName"/>
                      <datalist id="taskOwnerDatalist">
                        <option [value]="item" *ngFor="let item of userDropdownList"></option>
                      </datalist>
                      <label class="floating-label-special">Project Lead*</label>
                      <i class="ri-user-2-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="createdByUserName"/>
                      <label class="floating-label-special">Created By</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="startDate"/>
                      <label class="floating-label-special">Start Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="endDate" />
                      <label class="floating-label-special">End Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="decisionDate" />
                      <label class="floating-label-special">Decision Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="status">
                        <option value="" disabled selected>Select Status</option>
                        <option value="Active">Active</option>
                        <option value="On hold">On hold</option>
                        <option value="Archive">Archive</option>
                      </select>
                      <label for="status" class="floating-label-special">Project Status*</label>
                      <i class="ri-inbox-archive-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="customer" />
                      <label class="floating-label-special">Customer*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="totalHours" />
                      <label class="floating-label-special">Total Hours*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="remainingHours" />
                      <label class="floating-label-special">Remaining Hours</label>
                      <i class="ri-time-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="percentageCompleted" disabled />
                      <label class="floating-label-special">% of Project Completion</label>
                      <i class="ri-progress-2-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <textarea name="" id="" cols="20" rows="4" formControlName="projectDescription"></textarea>
                      <label class="floating-label-special">Project Description</label>
                      <i class="ri-file-list-3-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mt-3 mb-2">
                  <div class="d-flex gap-2 justify-content-end">
                    <button class="btn-secondary btn" (click)="backToMyProjectV2()">Cancel</button>
                    <div *ngIf="this.isPMOAdmin"><a class="btn" (click)="updateorcreateParametersV2()" *ngIf="this.currentProjectId">Update</a></div>
                    <a class="btn" (click)="updateorcreateParametersV2()" *ngIf="!this.currentProjectId">Create</a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </section>
  </article>
</main>